// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"908":"2aa8c8b1","2638":"7e300d9a","5202":"daf2524e","6547":"bdf19f13","8175":"afe2f7f1","9002":"bdf19f13","9878":"bdf19f13"}[chunkId] + ".chunk.css";
};